<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import {getconfig} from "@/api/index.js"
export default {
  data() {
    return {
      
    }
  },
  mounted(){
    getconfig().then(res=>{
      if(res.code==1){
        localStorage.setItem("config", JSON.stringify(res.data));
      }
    })
  },
  methods: {
   
  }
}
 </script> 
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  /* 这两个属性可以使页面上的字体抗锯齿,使用后字体看起来会更清晰 */
  -webkit-font-smoothing: antialiased; /*chrome、safari*/
  -moz-osx-font-smoothing: grayscale; /*firefox*/
  height: 100vh;color:#333;
}

* {
  margin: 0;
  padding: 0;
}
a {text-decoration: none;color:#2397CA}
.w1200 {width:1200px;margin:0 auto;}
.flex {display: flex}
.flex-1 {flex:1}
.flex-v {align-items: center}
.flex-c {justify-content: center;}
.mt_10 {margin-top:10px}
.mt_15 {margin-top:15px;}
.mt_20 {margin-top:20px;}
.mt_25 {margin-top:25px;}
.mt_30 {margin-top:30px;}
.mt_40 {margin-top:40px;}
.mt_45 {margin-top:45px;}
.mt_50 {margin-top:50px;}
.mt_80 {margin-top:80px;}
.mt_90 {margin-top:90px;}
.ml_10 {margin-left:10px;}
.mr_70 {margin-right:70px;}
.mr_50  {margin-right:50px;}
.mb_40 {margin-bottom: 40px;}
.f25 {font-size: 25px}
.f18 {font-size: 18px;}
.f16 {font-size: 16px;}
.f14 {font-size:14px;}
.f20 {font-size: 20px;}
.bold {font-weight: bold;}
.cen {text-align: center}
.el-dialog {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0px !important;
    border-radius:15px!important;
    .el-dialog__header {
     text-align: center;border-bottom:1px solid #CECECE;padding:25px;
      .el-dialog__title {
           font-size: 25px;font-weight: bold;
      }
      .el-icon-close {font-size:25px;font-weight: bold;}
      .el-dialog__headerbtn {right:20px;top:25px;}
    }
    .el-dialog__body {
      padding:0px;
    }
 }
.el-checkbox__inner {width:20px!important;height:20px!important;}
.el-checkbox__inner::after {
  width:4px!important;height:9px!important;left:7px!important;top:2px!important;border-width: 2px!important;
}
.el-table,.el-link--inner {
  // font-size:18px!important;
}
.el-table,.el-table thead {
    color:#333333!important;
}
.el-input__inner {border:1px solid #ccc!important;}
.mtitle {font-size: 20px;padding-top:30px;}
.orderlist {
    width:1200px;height:100%;display:flex; flex-direction: column;
    
    .fy {text-align: center;margin-top:30px;
        .el-pagination {}
    }
}
.mtitle2 {font-size:28px;text-align: center}
.red {color:#CC0000;}
.pad30 {padding:30px;}
.textnowap {white-space: nowrap;}
</style>
